var socialsBanner = document.querySelector('.socials-subscribe');
let lastScrollTop;

function showSocialsSubscribeBlock() {
    let delta = 150;
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(lastScrollTop - st) <= delta) return;
    if (lastScrollTop && Math.abs(lastScrollTop - st) >= delta) {
        checkSocialsSubscribePosition();
        socialsBanner.classList.add('visible');
        window.removeEventListener('scroll', showSocialsSubscribeBlock);
    }
    lastScrollTop = st;
}

function hideSocialsSubscribeBlock() {
    const expireDate = 365;
    setCookie('isSocialsSubscribeVisible', false, { 'expires' : expireDate, 'path' : '/', 'encode': true });
    socialsBanner.classList.remove('visible');
    socialsBanner.classList.add('hide');
    removeSocialsSubscribeCloseListeners();
}

function initSocialsSubscribeBlock() {
    const hasCookie = getCookie('isSocialsSubscribeVisible');
    if (!hasCookie && socialsBanner) {
        setSocialsSubscribeCloseListeners();
        document.addEventListener('closeFreeLesson', checkSocialsSubscribePosition);
        window.addEventListener('resize', checkSocialsSubscribePosition);
        window.addEventListener('scroll', showSocialsSubscribeBlock);
    }
}

function checkSocialsSubscribePosition() {
    if (!socialsBanner) return;
    const freeLessonBanner = document.querySelector('.free-lesson-container');
    let socialsBannerBottomPosition = 0;
    if (freeLessonBanner) {
        if (window.innerWidth < 768) {
            socialsBannerBottomPosition = freeLessonBanner.offsetHeight;
        }
        else {
            socialsBannerBottomPosition = freeLessonBanner.offsetHeight + 30;
        }
    }
    else {
        if (window.innerWidth >= 768) {
            socialsBannerBottomPosition = 30;
        }
    }
    socialsBanner.style.bottom = socialsBannerBottomPosition + 'px';
}

function setSocialsSubscribeCloseListeners() {
    const closeBtn = document.querySelector('.js-socials-subscribe-close-btn');
    closeBtn.addEventListener('click', hideSocialsSubscribeBlock);
}

function removeSocialsSubscribeCloseListeners() {
    const closeBtn = document.querySelector('.js-socials-subscribe-close-btn');
    closeBtn.removeEventListener('click', hideSocialsSubscribeBlock);
    document.removeEventListener('closeFreeLesson', checkSocialsSubscribePosition);
    window.removeEventListener('resize', checkSocialsSubscribePosition);
}

initSocialsSubscribeBlock();
